import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const iconProps = {
  size: '300',
  color: 'icon-core-subtle'
};
export default function CheckMarks({
  property
}) {
  switch (property) {
    case 'hs_stats_sent':
      return /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(SuccessIcon, Object.assign({}, iconProps))
      });
    case 'hs_stats_delivered':
      return /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(SuccessIcon, Object.assign({}, iconProps)), /*#__PURE__*/_jsx(SuccessIcon, Object.assign({}, iconProps))]
      });
    case 'hs_stats_read':
      return /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(SuccessIcon, Object.assign({}, iconProps, {
          color: "fill-accent-blue-default"
        })), /*#__PURE__*/_jsx(SuccessIcon, Object.assign({}, iconProps, {
          color: "fill-accent-blue-default"
        }))]
      });
    default:
      return null;
  }
}